import * as React from "react";
import Icon from '../../../icons';

export default class PartiesListingCell extends React.Component {
    constructor(props){
        super(props);
    }
    
    render(){
        const datasource= process.env.restrict_personal_party_for_claim_source.split(",").map(element => element.trim().toUpperCase());
        const orgs= process.env.restrict_personal_party_for_orgs.split(",").map(element => element.trim());
        const {data}=this.props;
        const {hidepersonalParty,addingwith}=this.props.extraData;
   
        return(
            <React.Fragment>
                <li className="sticky">
                    <label>{data.filter}</label>
                </li>
                {
                    data.partyitems.map((item,key)=>{
                        return (
                            <li key={key} className={(key==data.partyitems.length-1)?"lastElement":""}>
                                <div className="colFlex mr">
                                    <span>{item.party_org || item.party_name}</span>
                                    <label>{(item.party_address1  ? item.party_address1 + "," :"") + item.party_city}</label>
                                </div>
                                <div className="partyAction animated fast fadeInRightSmall">
                                {
                                    item.canEditDel ?
                                    <React.Fragment>
                                        <span className="iconRipple mr" onClick={() => this.props.extraData.editClick(item.party_id)}>
                                            <Icon name="edit" className="icon" />
                                        </span>
                                        <span className="iconRipple mr"  onClick={() => this.props.extraData.deleteClick(item.party_id)}>
                                            <Icon name="delete" className="icon" />
                                        </span>
                                    </React.Fragment>
                                    :
                                    null
                                }
                                <span className="iconRipple mr" onClick={() => this.props.onItemClick(item.party_id)}>
                                    <Icon name="info" className="icon infoGrey" />
                                </span>
                                </div>
                                {
                                    item.canAssociate ? hidepersonalParty && !item.IsGlobal ? null:
                                    <span className="iconRipple" href="javascript:void(0)" onClick={() => this.props.onCellClick(item)}>
                                        <Icon name="add" className="icon infoGrey" />
                                    </span>                            
                                    :
                                    null
                                }
                            </li>
                        )
                    })
                }
            </React.Fragment>
        );
    }
}
